import { ClassNames, css, keyframes } from '@emotion/react';
import { Link, graphql, navigate } from 'gatsby';
import { useTranslation } from 'gatsby-plugin-react-i18next';
import React from 'react';
import 'src/components/TopBar/dropdownMenu/index.css';
import { downloadLinks } from 'src/config';
import { getOS } from 'src/helpers';
import Analytics from 'src/helpers/analytics';
import {
  ActiveLinkStyle,
  DropdownDownloadButton,
  DropdownMenuContainer,
  DropdownMenuItem,
  DropdownOverlay,
  LinkStyle,
} from 'src/styles/topbar';

export const overlayKeyframe = keyframes`
  from {
    height: 0;
  }
  to {
    height: 100%; 
  }
`;

interface DropdownMenuProps {
  isOpen: boolean;
  onCloseMenu: () => void;
}

const DropdownMenu: React.FC<DropdownMenuProps> = ({ isOpen, onCloseMenu }) => {
  const { t } = useTranslation();

  const onAppClick = (name: string) => {
    Analytics.logAppButtonClick(name);
  };

  const onDownloadClick = () => {
    const platform = getOS();

    if (!platform) {
      onCloseMenu();
      return;
    }

    if (typeof window !== `undefined`) {
      platform === 'ios' ? navigate(`${downloadLinks.appStore}`) : navigate(`${downloadLinks.googlePlay}`);
    }
  };

  return (
    <ClassNames>
      {({ cx }) => (
        <>
          {isOpen ? (
            <DropdownOverlay
              css={css`
                animation: ${overlayKeyframe} 0.7s ease;
              `}
              onClick={onCloseMenu}
            />
          ) : null}

          <DropdownMenuContainer className={cx({ mobileDropdownMenu: true, open: isOpen })}>
            <Link style={LinkStyle} to={'/aboutus'} activeStyle={ActiveLinkStyle}>
              <DropdownMenuItem onClick={() => onAppClick('aboutus')}>{t('dropdownMenu.about')}</DropdownMenuItem>
            </Link>
            <Link style={LinkStyle} to={'/features'} activeStyle={ActiveLinkStyle}>
              <DropdownMenuItem onClick={() => onAppClick('features')}>{t('dropdownMenu.features')}</DropdownMenuItem>
            </Link>
            <Link style={LinkStyle} to={'/frequentlyaskedquestions'} activeStyle={ActiveLinkStyle}>
              <DropdownMenuItem onClick={() => onAppClick('q&a')}>{t('dropdownMenu.q&a')}</DropdownMenuItem>
            </Link>
            <Link style={LinkStyle} to={'/magazine'} activeStyle={ActiveLinkStyle}>
              <DropdownMenuItem onClick={() => onAppClick('magazine')}>{t('dropdownMenu.magazine')}</DropdownMenuItem>
            </Link>
            <Link style={LinkStyle} to={'/plans'} activeStyle={ActiveLinkStyle}>
              <DropdownMenuItem onClick={() => onAppClick('plans')}>{t('dropdownMenu.plans')}</DropdownMenuItem>
            </Link>
            {/* <Link style={LinkStyle} to={'/contactus'} activeStyle={ActiveLinkStyle}>
              <DropdownMenuItem onClick={() => onAppClick('q&a')}>{t('dropdownMenu.contact')}</DropdownMenuItem>
            </Link> */}
            <DropdownDownloadButton onClick={onDownloadClick}>{t('dropdownMenu.download')}</DropdownDownloadButton>
          </DropdownMenuContainer>
        </>
      )}
    </ClassNames>
  );
};
export default DropdownMenu;
